/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomDefinitionUpdateRequest extends models.AppSecopsSbomDefinitionBase {
    getFixupPrototypeFunction() { return AppSecopsSbomDefinitionUpdateRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomDefinitionUpdateRequest>): AppSecopsSbomDefinitionUpdateRequest {
        let obj = Object.assign(new AppSecopsSbomDefinitionUpdateRequest(), model);
        AppSecopsSbomDefinitionUpdateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomDefinitionUpdateRequest>): AppSecopsSbomDefinitionUpdateRequest {
        if (!model) return null;
        return AppSecopsSbomDefinitionUpdateRequest.newInstance(<AppSecopsSbomDefinitionUpdateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomDefinitionUpdateRequest) {
        if (!obj) return;

        models.AppSecopsSbomDefinitionUpdateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomDefinitionUpdateRequest): boolean {
        if (models.AppSecopsSbomDefinitionBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomDefinitionUpdateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.resource_mapping_details) {
            models.AppSecopsSbomResourceMappingDetails.fixupPrototype(this.resource_mapping_details);
        }
    }

    /**
     * Details of resources mapped to SBOM.
     */
    resource_mapping_details: models.AppSecopsSbomResourceMappingDetails;

}
